import React, { useState, useEffect } from "react";
import TestServerConnection from "../components/TestServerConnection";
import GetServerData from "../components/GetServerData";




function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}

function ContactPage(){
    const windowSize = useWindowSize();
    return (
        // <div style={{ padding: 32, paddingLeft: windowSize.width > 600 ? windowSize.width / 2.5 : 16}}>
        <div style={{ padding: 32, paddingLeft: 20, alignItems: "left" }}>
            <h2>Contact Us</h2>
            <p>If you have any questions, feel free to reach out!</p>
            <p>Email:   support@carmelhousesupply.com</p>
            <p>Phone:   (321)442-1947</p>
            {/* <div>
                <TestServerConnection />
            </div>
            <div>
                <GetServerData />
            </div> */}
        </div>
        
    );
}
export default ContactPage;